__webpack_require__.p = "https://cdn.medprev.online/web-app/assets/7e7e25bf/_next/";